import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AlbumManagerService } from '../../shared-api/albums/album-manager.service';
import { BroadcastService } from '../../core/services/broadcast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Album } from '../../shared-api/albums/album.model';
import { ImageAssetComponent, ImageAssetEditWrapper } from '../../shared-ui/image-asset/image-asset.component';
import { ImageManagerService } from '../../shared-api/images/image-manager.service';
import { MyApp } from '../../shared-api/common/enumerations';
import { OrganizationManagerService, ViewMode } from '../../shared-api/organization/organization-manager.service';

@Component({
    selector: 'myapp-album',
    templateUrl: './album.component.html',
    styleUrls: [ './album.component.less' ]
})
export class AlbumComponent implements OnInit
{
    @ViewChildren(ImageAssetComponent, { read: ElementRef }) images: QueryList<ElementRef>;

    album: Album;
    allPhotosSelected = false;
    currentDownloadImage: ImageAssetEditWrapper;
    currentDownloadCount = 0;
    downloadComplete = false;
    failedDownloadCount = 0;
    loading = true;
    numPhotos: number;
    numPhotosSelected = 0;
    stoppingDownload = false;
    successfulDownloadCount = 0;
    totalDownloadCount = 0;
    visibleImageAssets: ImageAssetEditWrapper[] = [];

    private imagesToDownload: ImageAssetEditWrapper[] = [];

    ViewMode = ViewMode;

    constructor(private albumManager: AlbumManagerService,
                private broadcastService: BroadcastService,
                private imageManager: ImageManagerService,
                public orgManager: OrganizationManagerService,
                private route: ActivatedRoute,
                private router: Router) { }

    ngOnInit()
    {
        this.broadcastService.showHeader.next(true);
        this.route.params.subscribe(params =>
        {
            const albumId = params['id'] == null ? 0 : +params['id'];
            const index = params['index'] == null ? 0 : +params['index'];
            this.loadAlbum(albumId, index);
        });
    }

    private loadAlbum(id: number, index: number)
    {
        this.loading = true;
        this.albumManager.getAlbum(id, true).subscribe((parentAlbum: Album) =>
        {
            this.album = parentAlbum;
            this.loading = false;
            this.visibleImageAssets = <ImageAssetEditWrapper[]>this.album.ImageAssets;
            this.numPhotos = this.album.ImageAssets.filter(ia => ia.AssetType === MyApp.AssetType.Image).length;
        });
    }

    onPhotoClicked(index: number)
    {
        this.router.navigate([ '/photos', this.album.Id, index ]);
    }

    onImageAssetSelected(imageAsset: ImageAssetEditWrapper)
    {
        this.numPhotosSelected += (imageAsset.Selected ? 1 : -1);
        this.allPhotosSelected = (<ImageAssetEditWrapper[]>this.album.ImageAssets).every(ia => ia.AssetType !== MyApp.AssetType.Image || ia.Selected);
    }

    onDownloadClicked()
    {
        this.imagesToDownload = (<ImageAssetEditWrapper[]>this.album.ImageAssets).filter(ia => ia.Selected);
        this.downloadComplete = false;
        this.stoppingDownload = false;
        this.currentDownloadCount = 0;
        this.successfulDownloadCount = 0;
        this.failedDownloadCount = 0;
        this.totalDownloadCount = this.imagesToDownload.length;
        this.downloadNextImage();
    }

    onStopDownload()
    {
        this.stoppingDownload = true;
    }

    private downloadNextImage() {
        if (this.imagesToDownload.length === 0 || this.stoppingDownload) {
            // Done!
            this.downloadComplete = true;
            return;
        }

        this.currentDownloadCount++;
        this.currentDownloadImage = this.imagesToDownload.shift();
        this.imageManager.downloadImageAsset(this.currentDownloadImage)
            .subscribe(result =>
            {
                if (result)
                {
                    this.successfulDownloadCount++;
                }
                else
                {
                    this.failedDownloadCount++;
                }

                this.downloadNextImage();
            });
    }

    onFinishedDownload()
    {
        this.totalDownloadCount = 0;
        this.allPhotosSelected = false;
        this.numPhotosSelected = 0;
        (<ImageAssetEditWrapper[]>this.album.ImageAssets).forEach(ia => ia.Selected = false);
    }

    onSelectAllChanged()
    {
        (<ImageAssetEditWrapper[]>this.album.ImageAssets).forEach(ia => ia.Selected = ia.AssetType === MyApp.AssetType.Image && this.allPhotosSelected);
        this.numPhotosSelected = this.allPhotosSelected ? (<ImageAssetEditWrapper[]>this.album.ImageAssets).filter(ia => ia.Selected).length : 0;
    }
}
